module.exports = __webpack_public_path__ + "img/icons BFr_16.43dee92d.png";